import { isNewPresenter } from '@/pages/agents/components/avatars/utils/IsNewPresenter';
import { DEFAULT_TOP_AVATARS } from '@/pages/agents/constants';
import { useFlag } from '@/services/featureFlags';
import { useUserSettings } from '@/state/user-settings/UserSettingsProvider';
import { Presenter } from '@d-id/types';
import { useCallback, useMemo } from 'react';

export const useAgentsPresentersSorting = () => {
    const { userSettings } = useUserSettings();
    const topAvatars: string[] = useFlag('top_avatars', DEFAULT_TOP_AVATARS);
    const favoriteAvatars: string[] = useMemo(() => userSettings?.preferences?.avatars || [], [userSettings?.preferences?.avatars]);

    const sortPresenters = useCallback(
        (presenters: Presenter[]) => {
            return [...presenters].sort((a, b) => {
                const isAFavorite = favoriteAvatars.includes(a.id);
                const isBFavorite = favoriteAvatars.includes(b.id);

                if (isAFavorite && !isBFavorite) return -1;
                if (!isAFavorite && isBFavorite) return 1;

                const isATop = topAvatars.includes(a.id);
                const isBTop = topAvatars.includes(b.id);

                if (isATop && !isBTop) return -1;
                if (!isATop && isBTop) return 1;

                if (isATop && isBTop) {
                    return topAvatars.indexOf(a.id) - topAvatars.indexOf(b.id);
                }

                const isANew = isNewPresenter(a);
                const isBNew = isNewPresenter(b);

                if (isANew && !isBNew) return -1;
                if (!isANew && isBNew) return 1;

                return a.name.localeCompare(b.name);
            });
        },
        [favoriteAvatars, topAvatars]
    );

    return sortPresenters;
};
